<div class="card">
  <h5>Virtual Scroll with Preloaded Data (10000 Rows)</h5>
  <uv-table [columns]="cols" [value]="cars" [scrollable]="true" scrollHeight="250px" [virtualScroll]="true" [virtualScrollItemSize]="46">
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th style="width: 20%;">
            {{col.header}}
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
      <tr style="height:46px">
        @for (col of columns; track col) {
          <td>
            {{rowData[col.field]}}
          </td>
        }
      </tr>
    </ng-template>
  </uv-table>
</div>

<!-- <div class="card">
<h5>Virtual Scroll with Lazy Loading from a Remote Datasource (10000 Rows)</h5>
<mytable [columns]="cols" [value]="virtualCars" [scrollable]="true" scrollHeight="250px" [rows]="10000"
  [virtualScroll]="true" [virtualScrollItemSize]="46" [lazy]="true" (onLazyLoad)="loadCarsLazy($event)">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" style="width: 20%;">
        {{col.header}}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr style="height:46px">
      <td *ngFor="let col of columns">
        {{rowData[col.field]}}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="loadingbody" let-columns="columns">
    <tr style="height:46px">
      <td *ngFor="let col of columns; let even = even">
        <p-skeleton [ngStyle]="{'width': even ? (col.field === 'year' ? '30%' : '40%') : '60%'}"></p-skeleton>
      </td>
    </tr>
  </ng-template>
</mytable>
</div> -->
